import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../../shared/_guards/auth.guard';
import { MembersListComponent } from './members-list/members-list.component';
import { MembersComponent } from './members/members.component';
import { MembersModifyComponent } from './members-modify/members-modify.component';
import { MembersBookingComponent } from './members-booking/members-booking.component';
import { MembersTransactionHistoryComponent } from './members-transaction-history/members-transaction-history.component';
import { MembersShoppingCartComponent } from './members-shopping-cart/members-shopping-cart.component';
import { MembersCommentsComponent } from './members-comments/members-comments.component';
import { MembersDetailsComponent } from './members-details/members-details.component';
import { MembersProfileChangesComponent } from './members-profile-changes/members-profile-changes.component';
import { MembersOldTransactionHistoryComponent } from './members-old-transaction-history/members-old-transaction-history.component';
import { MembersSubscriptionHistoryListComponent } from './members-subscription-history-list/members-subscription-history-list.component';
import { MembersActivityLogComponent } from './members-activity-log/members-activity-log.component';
import { MembersHardDeleteAuditListComponent } from './members-hard-delete-audit-list/members-hard-delete-audit-list.component';

const routes: Routes = [
  {
    path: 'members', component: MembersComponent, canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', component: MembersListComponent, canActivate: [AuthGuard] },
      { path: 'history', pathMatch: 'full', component: MembersSubscriptionHistoryListComponent, canActivate: [AuthGuard] },
      { path: 'hard-delete-audit', pathMatch: 'full', component: MembersHardDeleteAuditListComponent, canActivate: [AuthGuard] },
      { path: 'edit/:id', pathMatch: 'full', component: MembersDetailsComponent, canActivate: [AuthGuard] },
      {
        path: 'modify/:id', component: MembersModifyComponent, canActivate: [AuthGuard],
        children: [
          { path: '', pathMatch: 'full', component: MembersBookingComponent, },
          { path: 'booking', pathMatch: 'full', component: MembersBookingComponent, canActivate: [AuthGuard] },
          { path: 'old-transaction-history', pathMatch: 'full', component: MembersOldTransactionHistoryComponent,
            canActivate: [AuthGuard] },
          { path: 'transaction-history', pathMatch: 'full', component: MembersTransactionHistoryComponent, canActivate: [AuthGuard] },
          { path: 'shopping-cart', pathMatch: 'full', component: MembersShoppingCartComponent, canActivate: [AuthGuard] },
          { path: 'comments', pathMatch: 'full', component: MembersCommentsComponent, canActivate: [AuthGuard] },
          { path: 'profile-changes', pathMatch: 'full', component: MembersProfileChangesComponent, canActivate: [AuthGuard] },
          { path: 'activity-log', pathMatch: 'full', component: MembersActivityLogComponent, canActivate: [AuthGuard] },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MembersManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/members/members-management/members-management-routing.module.ts